import { createContextScope, type Scope } from '@radix-ui/react-context';
import { type RefObject } from 'react';

export const PANEL_NAME = 'Panel';
export const PANEL_CONTENT_NAME = 'PanelContent';
export const PANEL_OVERLAY_NAME = 'PanelOverlay';

export type ScopeProps<P> = P & {
  __scopePanel?: Scope;
};

const [createPanelContext] = createContextScope(PANEL_NAME);

export type PanelContextValue = {
  contentId: string;
  contentRef: RefObject<HTMLDivElement>;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOpenClose: () => void;
  onOpenToggle: () => void;
  triggerRef: RefObject<HTMLButtonElement>;
};

export const [PanelProvider, usePanelContext] = createPanelContext<PanelContextValue>(PANEL_NAME);
